import { Reveal } from '../hooks/useReveal'

export const Features = ({ capabilities = [] }) => (
  <section className="section" id="capabilities">
    <div className="container">
      <Reveal className="section-head">
        <div>
          <p className="eyebrow">Skills</p>
          <h2 className="section-title">What I work with.</h2>
        </div>
      </Reveal>

      <div className="cap-grid">
        {capabilities.map((cap, i) => (
          <Reveal key={cap.title} delay={i * 70} className="cap">
            <p className="cap__index">{String(i + 1).padStart(2, '0')}</p>
            <h3 className="cap__title">{cap.title}</h3>
            <p className="cap__body">{cap.body}</p>
            <ul className="cap__items">
              {cap.items.map((item) => (
                <li className="chip" key={item}>
                  {item}
                </li>
              ))}
            </ul>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
)
